import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./config";

export const loginUser = async (email, password) => {
  // 1. Authenticate
  const cred = await signInWithEmailAndPassword(auth, email, password);
  const uid = cred.user.uid;

  // 2. Fetch user profile
  const userRef = doc(db, "users", uid);
  const snap = await getDoc(userRef);

  if (!snap.exists()) {
    throw new Error("User profile not found");
  }

  return {
    uid,
    ...snap.data()
  };
};
